export const parseArrayUrlParam = (paramName: string): string[] => {
    if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
        return [];
    }

    if (typeof URLSearchParams === 'undefined' || typeof window === 'undefined') {
        return [];
    }

    const urlParams = new URLSearchParams(window.location?.search ?? '');
    const paramValue = urlParams.get(paramName);

    if (!paramValue) {
        return [];
    }

    return paramValue
        .split(',')
        .map((value) => decodeURIComponent(value.trim()))
        .filter((value) => value.length > 0);
};
